module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_03.58a1db7d.jpg";